import { useCallback, useEffect, useMemo, useState } from "react";

import { Box } from "../../../../../../dtos/box";
import { OwnerOption } from "../interfaces";

import { useCustomers } from "./useCustomers";
import { useEmployees } from "./useEmployees";

export function useOwnerOptions(
    box: Box | null,
    boxOwners: { id: number }[],
): {
    potentialOwnerOptions: OwnerOption[];
    showOrgCustomers: boolean,
    setShowOrgCustomers: (value: boolean) => void,
    load: () => void;
    loading: boolean;
} {
    const [ownerOptions, setOwnerOptions] = useState<OwnerOption[]>([]);
    const isBankBox = Boolean(box ? box.isBankBox : false);
    const {
        customers,
        showOrgCustomers,
        setShowOrgCustomers,
        load: loadCustomers,
        loading: loadingCustomers,
    } = useCustomers(
        box ? box.orgId : undefined,
        box ? box.siteId : undefined,
        !isBankBox,
    );
    const {
        employees,
        load: loadEmployees,
        loading: loadingEmployees,
    } = useEmployees(
        box ? box.orgId : undefined,
        box ? box.siteId : undefined,
        isBankBox,
    )

    useEffect(() => {
        setOwnerOptions(customers.map(it => ({
            label: `${it.fullName}\n${it.phone}\n${it.email}`,
            value: it.id,
        })));
    }, [customers]);

    useEffect(() => {
        setOwnerOptions(employees.map(it => ({
            label: `${it.fullName}\n${it.phoneNumber}\n${it.email}`,
            value: it.id,
        })));
    }, [employees]);

    const load = useCallback(() => {
        loadCustomers();
        loadEmployees();
    }, [loadCustomers, loadEmployees]);

    const potentialOwnerOptions = useMemo(() => {
        const boxOwnersIds = boxOwners.map(it => it.id);
        return ownerOptions.filter(it => !boxOwnersIds.includes(it.value));
    }, [ownerOptions, boxOwners]);
    return {
        potentialOwnerOptions,
        showOrgCustomers,
        setShowOrgCustomers,
        load,
        loading: loadingCustomers || loadingEmployees,
    };
}
